import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";

export default function Introloading({ onFinish }) {
  const rootRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        onComplete: () => {
          // hide intro and show site
          gsap.to(rootRef.current, {
            autoAlpha: 0,
            duration: 0.4,
            delay: 0.2,
            onComplete: onFinish
          });
        }
      });

      // initial state
      // gsap.set(".bl-text", { yPercent: -160 });

      // drop letters
      tl.to(".bl-text", {
        yPercent: 0,
        duration: 1.2,
        ease: "power4.out",
        stagger: 0.15
      })

      // little bounce
      .to(".bl-text", {
        y: -10,
        duration: 0.3,
        ease: "power2.out"
      })
      .to(".bl-text", {
        y: 0,
        duration: 0.4,
        ease: "bounce.out"
      })

      // hold logo
      .to({}, { duration: 0.6 })

      // exit animation
      .to(".bl-text", {
        yPercent: -160,
        duration: 1,
        ease: "power4.in",
        stagger: 0.08
      });

    }, rootRef);

    return () => ctx.revert();
  }, [onFinish]);

  return (
    <div ref={rootRef} className="home-intro">
      <div className="big-logo-wrapper">

        <div className="block t-1">
          <div className="bl-text is-1">P</div>
        </div>

        <div className="bl-center">
          <div className="block t-2">
            <div className="bl-text is-2">t</div>
          </div>
          <div className="block t-3">
            <div className="bl-text is-3">h</div>
          </div>

           
        </div>

       <div className="block t-4">
          <div className="bl-text is-4">r</div>
        </div>
         <div className="block t-5">
          <div className="bl-text is-5">u</div>
        </div>
         <div className="block t-6">
          <div className="bl-text is-6">P</div>
        </div>
      </div>
    </div>
  );
}